import { render, staticRenderFns } from "./ExclusionGrid.vue?vue&type=template&id=4fb39448&scoped=true"
import script from "./ExclusionGrid.vue?vue&type=script&lang=js"
export * from "./ExclusionGrid.vue?vue&type=script&lang=js"
import style0 from "./ExclusionGrid.vue?vue&type=style&index=0&id=4fb39448&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb39448",
  null
  
)

export default component.exports